import { React, useState, useEffect } from 'react'
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import { ReactComponent as EditIcon } from "../../../../Assets/img/icons/Edit Pencil.svg"
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import PublicIcon from '@mui/icons-material/Public';
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import { CgColorPicker } from "react-icons/cg";
import { useCardDetailContext } from '../../../CardDetailContext';
import MapIntegration from '../../Mapintegration';
import { MuiTelInput } from 'mui-tel-input'
import { useUserDetailContext } from '../../../UserDetailContext';
import { IconButton, Dialog, DialogContent } from "@mui/material";
import { DialogContentText, InputAdornment, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import useNavigationGuard from './useNavigationGuard';
import AccordionItem from '../../../Utilities/AccordionItem';
import { CleaningServices } from '@mui/icons-material';
import { useQuantityContext } from '../../../QuantityContext';
import useApi from '../../../Utilities/useAPI';
import Mapintegration from '../../Mapintegration';
import MapWithAddress from '../../MapWithAddress';
import { getAllCardDetailsReducer, getAllCardInfoReducer, getVisitingCardReducer } from '../../../../Redux/Reducers/CardReducer';
import { useDispatch } from 'react-redux';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const Contactdetails = ({ handleSuccess, handleFailure }) => {

  const apiKey = process.env.REACT_APP_API_KEY; // actual API key
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };
  const { callApiFunction, loading, error } = useApi();

  const dispatch = useDispatch();
  const { setisNavigationBlocked } = useQuantityContext();
  const { ContactStyles, updateContactStyles, setContactStyles, CardStyles, cardDetails, updateCardDetails, } = useCardDetailContext();
  const { userDetails } = useUserDetailContext();
  const [phoneNumber, setPhoneNumber] = useState(ContactStyles.mobile_number || userDetails.phone);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [emailId, setemailId] = useState(ContactStyles.email || '');
  const [SaveEnable, setSaveEnable] = useState(false);
  const [initialContactStyles, setInitialContactStyles] = useState({});
  const iconColor = CardStyles?.colorLayout || '#0044c6';
  const [searchValue, setSearchValue] = useState('');
  const [latitude, setLatitude] = useState(12.979871024899435);
  const [longitude, setLongitude] = useState(77.60654611960474);

  const { handleInfo } = useQuantityContext();
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    // Split the input value and update latitude and longitude
    const [lat, lon] = value.split(',').map(coord => parseFloat(coord.trim()));
    if (!isNaN(lat) && !isNaN(lon)) {
      setLatitude(lat);
      handleInputChange2('latitude')(lat);
      setLongitude(lon);
      handleInputChange2('longtitude')(lon);
    }
    else {
      setLatitude(`12.979871024899435`);
      handleInputChange2('latitude')('');
      setLongitude(`77.60654611960474`);
      handleInputChange2('longtitude')('');
    }
  };

  const handleInputChange2 = (fieldName) => (value) => {
    updateContactStyles({ [fieldName]: value });
  }

  useEffect(() => {
    setInitialContactStyles(ContactStyles);
  }, []);

  useEffect(() => {
    setSaveEnable(JSON.stringify(initialContactStyles) !== JSON.stringify(ContactStyles));
    setisNavigationBlocked(JSON.stringify(initialContactStyles) !== JSON.stringify(ContactStyles));
  }, [ContactStyles, initialContactStyles]);

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
    setIsPhoneNumberEmpty(false);
    setCode('');
    setErrorMessage('');
  };

  const handleEmailChange = (event) => {
    setemailId(event.target.value);
    setCode('');
    setErrorMessage('');
  };

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateContactStyles({ [fieldName]: newValue });
  };

  const toggleVisibility = (fieldName) => {
    setContactStyles((prevStyles) => ({
      ...prevStyles,
      [fieldName]: !prevStyles[fieldName],
    }));
  };


  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showCode, setShowCode] = useState(false);
  const [showCodeError, setShowCodeError] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);

  const toggleCodeVisibility = () => {
    setShowCode(prev => !prev);
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
    setErrorMessage('');
  };

  const [isDialogSendOtpOldNum, setisDialogSendOtpOldNum] = useState(false);
  const [isDialogSendOtpNewNum, setisDialogSendOtpNewNum] = useState(false);

  const formatPhoneNumber = (phoneNumber) => {
    // Match the country code (1 to 3 digits) and the rest of the number
    const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
    if (match) {
      // Extract and clean the rest of the number
      const countryCode = match[1];
      const cleanedRestOfNumber = match[2].replace(/\s+/g, '');
      return `${countryCode} ${cleanedRestOfNumber}`;
    }
    // Return the original phoneNumber if it doesn't match the expected format
    return phoneNumber;
  };

  const handleCodeSubmitNewNum = () => {
    {
      // axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorverify-mobile-otp`, {
      //   mobileNumber: `${phoneNumber}`,
      //   otp: parseInt(code),
      // }, { headers: headers })
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/mail/verify-mobile-otp`,
        {
          mobileNumber: `${phoneNumber}`,
          otp: parseInt(code),
        },
        {
          headers: headers
        }
      )
        .then(response => {
          setCode('');
          setErrorMessage('');
          console.log("Mobile OTP verified successfully");
          const cleanedPhoneNumber = formatPhoneNumber(phoneNumber);
          updateContactValue('mobile_number', cleanedPhoneNumber);
          handleSuccess("OTP Verified!");
          setisDialogSendOtpNewNum(false);
          setInitialContactStyles(ContactStyles);
        })
        .catch(error => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify mobile OTP:", error);
        });
    }
  }

  const sendOtpOldNumber = async () => {
    if (!phoneNumber) {
      // alert("Mobile is empty")
      handleInfo("Mobile is empty");

    }
    else if (phoneNumber == ContactStyles.mobile_number) {
      // alert("Mobile Number did not change");
      handleFailure("Mobile Number did not change");
    }
    else {
      setMinutes(0);
      setSeconds(60);
      // axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`, {
      //   mobileNumber: `${ContactStyles.mobile_number}`,
      // }, { headers: headers })
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mail/Contact-send-mob-otp`,
        {
          mobileNumber: `${ContactStyles.mobile_number}`,
        },
        { headers: headers })
        .then(response => {
          setisDialogSendOtpOldNum(true);
          console.log("Mobile OTP sent successfully");
        })
        .catch(error => {
          console.error("Failed to send mobile OTP:", error);
        });
    }
  };

  const handleCodeSubmitOldNum = () => {
    {
      // axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorverify-mobile-otp`, {
      //   mobileNumber: `${ContactStyles.mobile_number}`,
      //   otp: parseInt(code),
      // },
      //   { headers: headers })
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/mail/verify-mobile-otp`,
        {
          mobileNumber: `${ContactStyles.mobile_number}`,
          otp: parseInt(code),
        },
        {
          headers: headers
        }
      )
        .then(response => {
          sendOTPNewNumber();
          setMinutes(0);
          setSeconds(60);
          setCode('');
          handleSuccess("OTP Verified!");
          setisDialogSendOtpNewNum(true);
          setisDialogSendOtpOldNum(false);
          setErrorMessage('');
          console.log("Mobile OTP verified successfully");
          setInitialContactStyles(ContactStyles);
        })
        .catch(error => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify mobile OTP:", error);
        });
    }
  }

  const sendOTPNewNumber = async () => {
    if (!phoneNumber) {
      // alert("Mobile is empty")
      handleInfo("Mobile is empty");
    }
    else if (phoneNumber == ContactStyles.mobile_number) {
      // alert("Mobile Number did not change");
      handleFailure("Mobile Number did not chage")
    }
    else {
      setMinutes(0);
      setSeconds(60);
      // axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`, {
      //   mobileNumber: `${phoneNumber}`,
      // }, { headers: headers })
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mail/Contact-send-mob-otp`,
        {
          mobileNumber: `${phoneNumber}`,
        },
        { headers: headers })
        .then(response => {
          console.log("Mobile OTP sent successfully");
        })
        .catch(error => {
          console.error("Failed to send mobile OTP:", error);
        });
    }
  };

  useEffect(() => {
    // Start the timer only when TwoFactorAuthSecondPage becomes true
    const interval = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        setCode('');
        clearInterval(interval);
      }
      else {
        // Decrease seconds if greater than 0
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          if (minutes > 0) {
            setMinutes(minutes - 1);
            setSeconds(59); // Reset seconds to 59 when minutes decrease
          }
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };

  }, [seconds, minutes]);

  const updateContactValue = (fieldName, newValue) => {
    setContactStyles((prevState) => ({
      ...prevState,
      [fieldName]: newValue,
    }));
  };
  const [isDialogOldEmail, setisDialogOldEmail] = useState(false);
  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);

  const handlecloseDialog = () => {
    setisDialogSendOtpNewNum(false);
    setisDialogSendOtpOldNum(false);
    setCode('');
    setErrorMessage('');
    setPhoneNumber(ContactStyles.mobile_number);
    setemailId(ContactStyles.email);
    setisDialogNewEmail(false);
    setisDialogOldEmail(false);
  }

  const SendOtpOldEmail = () => {
    if (!emailId) {
      // alert("Email id is empty")
      handleInfo("Email id is empty.");
    }
    else if (emailId == ContactStyles.email) {
      // alert("same email")
      handleFailure("same email id.");
    }
    else {
      setisDialogOldEmail(true);
      setMinutes(0);
      setSeconds(60);
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`, {
        email: `${ContactStyles.email}`,
      }, { headers: headers })
        .then(response => {
          console.log("OTP sent successfully");
        })
        .catch(error => {
          // Handle error, such as displaying an error message to the user
          console.error("Failed to send OTP:", error);
        });
    }
  }

  const handleCodeSubmitOldEmail = () => {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
      email: `${ContactStyles.email}`,
      otp: code,
    }, { headers: headers })
      .then(response => {
        setCode('');
        setErrorMessage('');
        console.log("OTP verified successfully");
        setisDialogOldEmail(false);
        setisDialogNewEmail(true);
        sendOtpNewEmail();
        handleSuccess("OTP Verified!");
      })
      .catch(error => {
        setCode('');
        setErrorMessage("Incorrect OTP. Please try again.");
        console.error("Failed to verify OTP:", error);
      });
  }

  const sendOtpNewEmail = () => {
    if (!emailId) {
      // alert("Email id is empty")
      handleInfo("Email id is empty.");
    }
    else if (emailId == ContactStyles.email) {
      // alert("same email")
      handleFailure("same email.");
    }
    else {
      setMinutes(0);
      setSeconds(60);
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`, {
        email: `${emailId}`,
      }, { headers: headers })
        .then(response => {
          setisDialogNewEmail(true);
          console.log("OTP sent successfully");
        })
        .catch(error => {
          // Handle error, such as displaying an error message to the user
          console.error("Failed to send OTP:", error);
        });
    }
  }

  const [isDomainVerifyDoneHere, setIsDomainVerifyDoneHere] = useState(false);

  const checkDomainVerification = async (email) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/get-company-data`, {
        email: email
      });
      return response.data.isDomainVerified;
    } catch (error) {
      console.error("Failed to check domain verification:", error);
      return false;
    }
  };

  const handleCodeSubmitNewEmail = async () => {
    if (ContactStyles.card_type === 'Professional') {
      // const isDomainVerified = await checkDomainVerification(emailId);
      setIsDomainVerifyDoneHere(true);

      // if (!isDomainVerified) {
      //   setErrorMessage("Domain is not verified. Please check your email domain.");
      //   return; // Exit the function if the domain is not verified
      // }
    }

    // Only proceed with OTP verification if the domain is verified or the card type is not 'Professional'
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
      email: `${emailId}`,
      otp: code,
    }, { headers: headers })
      .then(response => {
        setCode('');
        setErrorMessage('');
        setisDialogNewEmail(false);
        console.log("OTP verified successfully");
        handleSuccess("OTP Verified!");
        setisDialogNewEmail(false);
        updateContactValue('email', emailId);

        if (isDomainVerifyDoneHere) {
          updateCardDetails({ ['is_professional_verified']: true });
        }

        setInitialContactStyles(ContactStyles);
      })
      .catch(error => {
        setErrorMessage("Incorrect OTP. Please try again.");
        console.error("Failed to verify OTP:", error);
      });
  }


  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(false);
  const [isEmailUpdate, setIsEmailUpdate] = useState(false);
  const [postalCodeError, setPostalCodeError] = useState('');

  useEffect(() => {
    setIsUpdateButtonEnabled(phoneNumber === ContactStyles?.mobile_number);
    setIsEmailUpdate(emailId === ContactStyles?.email);
  }, [phoneNumber, ContactStyles, emailId]);

  const handleSave = async (event) => {
    event.preventDefault();

    // if (!/^\d+$/.test(ContactStyles?.postal_code)) {
    //   setPostalCodeError('Postal code must contain only numbers.');
    //   return;
    // }

    if (isDomainVerifyDoneHere) {
      try {
        const response = await callApiFunction('savePersonalDetailsCard', cardDetails);

        console.log('Response from backend:', response.data);
        handleSuccess();
      }
      catch (error) {
        console.error('Error submitting card details:', error);
        handleFailure();
      }
    }

    try {
      const response = await callApiFunction('saveContactDetailsCard', ContactStyles);

      console.log('Response from contact backend:', response.data);
      await dispatch(getAllCardDetailsReducer());
      await dispatch(getAllCardInfoReducer());

      await dispatch(getVisitingCardReducer());
      setInitialContactStyles(ContactStyles);
      handleSuccess();
    }
    catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  }
  const handleSwitchChange = (event) => {
    const newValue = event.target.checked;
    updateContactStyles({ is_public: newValue });
  };

  const addressData = {

    city: "Banglore",
    state: "Karnataka",
    postal_code: "582101",
    country: "India",
  };

  const fullAddress = (ContactStyles?.address || ContactStyles.city)
    ? `${ContactStyles?.address}, ${ContactStyles?.city}, ${ContactStyles?.state} ${ContactStyles?.postal_code}, ${ContactStyles?.country}`
    : `${addressData.city}, ${addressData.state}, ${addressData.postal_code}, ${addressData.country}`;

  return (
    <div>
      {/* <Box className='my-4 card-info-box' sx=border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
      <div className='px-3'>
        <div className="card-edit-info-heading">
          <h5>Contact Information</h5>
          <span>Add contact and location details</span>
        </div>

        <div className="slideOpen-items-container mt-3">
          <AccordionItem
            key="callNo"
            network="callNo"
            icon={MdOutlinePhoneIphone}
            iconColor={iconColor}
            label="Call"
            input={phoneNumber}
            visible={ContactStyles.call_visible}
            toggleVisibility={() => toggleVisibility('call_visible')}
            onUpdate={handlePhoneChange}
            defaultOpen
            inputType="phone"
            handleResendOTP={sendOtpOldNumber}
            isUpdateButtonEnabled={isUpdateButtonEnabled}
          />

          <AccordionItem
            key="textNo"
            network="textNo"
            icon={SmsIcon}
            iconColor={iconColor}
            label="SMS"
            input={phoneNumber}
            visible={ContactStyles.sms_visible}
            toggleVisibility={() => toggleVisibility('sms_visible')}
            onUpdate={handlePhoneChange}
            inputType="phone"
            handleResendOTP={sendOtpOldNumber}
            isUpdateButtonEnabled={isUpdateButtonEnabled}
          />

          <AccordionItem
            key="emailId"
            network="emailId"
            icon={EmailIcon}
            iconColor={iconColor}
            label="E-mail"
            input={emailId}
            visible={ContactStyles.email_visible}
            toggleVisibility={() => toggleVisibility('email_visible')}
            onUpdate={handleEmailChange}
            inputType="email"
            handleResendOTP={(ContactStyles.card_type !== "Professional" || cardDetails?.CardType === "Customize_Professional") ? SendOtpOldEmail : sendOtpNewEmail}
            isUpdateButtonEnabled={isEmailUpdate}
          />

          <AccordionItem
            key="whatsapp"
            network="whatsapp"
            icon={WhatsappFilled}
            iconColor={iconColor}
            label="WhatsApp"
            input={phoneNumber}
            visible={ContactStyles.whatsapp_visible}
            toggleVisibility={() => toggleVisibility('whatsapp_visible')}
            onUpdate={handlePhoneChange}
            inputType="phone"
            handleResendOTP={sendOtpOldNumber}
            isUpdateButtonEnabled={isUpdateButtonEnabled}
          />
        </div>

        <div className="contact-location-container mt-3">
          <h5>Location</h5>
          <div>
            <Search className='ms-0 map-search-contact' style={{ border: "1px solid rgba(0, 0, 0, 0.12)", width: "100%" }}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
                className='search-bar'
                value={searchValue}
                onChange={handleSearchChange}
                style={{ width: "100%" }}
              />
            </Search>

            <div className="professional-map-container mt-3">
              {/* <MapIntegration style={{ borderRadius: "6px" }} latitude={latitude} longitude={longitude} />
               */}
              <MapWithAddress address={fullAddress} style={{ borderRadius: "6px" }} />
            </div>
          </div>

          <div className="mt-3 enter-location-manual">
            <h5 className='mb-3'>Enter Location</h5>
            <Grid container spacing={2}>
              {/* First Row */}
              <Grid item xs={12}>
                <TextField
                  multiline
                  minRows={1}
                  label="Address"
                  fullWidth
                  variant="outlined"
                  value={ContactStyles.address}
                  onChange={(e) => {
                    handleInputChange('address')(e);
                  }}
                />
              </Grid>
              {/* Second Row */}
              <Grid item xs={6}>
                <TextField
                  label="City"
                  fullWidth
                  variant="outlined"
                  value={ContactStyles.city}
                  onChange={(e) => {
                    handleInputChange('city')(e);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Postal Code"
                  fullWidth
                  variant="outlined"
                  value={ContactStyles.postal_code}
                  onChange={(e) => {
                    handleInputChange('postal_code')(e);
                    // The error message should be updated based on the validation
                    // if (/^\d*$/.test(e.target.value)) {
                    //   setPostalCodeError('');
                    // } else {
                    //   setPostalCodeError('Postal Code must contain only numbers.');
                    // }
                  }}
                  error={!!postalCodeError}
                  helperText={postalCodeError}
                />
              </Grid>
              {/* Third Row */}
              <Grid item xs={6}>
                <TextField
                  label="State"
                  fullWidth
                  variant="outlined"
                  value={ContactStyles.state}
                  onChange={(e) => {
                    handleInputChange('state')(e);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Country"
                  fullWidth
                  variant="outlined"
                  value={ContactStyles.country}
                  onChange={(e) => {
                    handleInputChange('country')(e);
                  }}
                />
              </Grid>
            </Grid>
            <FormControlLabel control={
              <Switch
                checked={ContactStyles?.is_public}
                onChange={handleSwitchChange}
              />}
              label="Enable View"
            />
          </div>
        </div>
      </div>

      <div className="save-bottom" style={{ textAlign: "right", backgroundColor: "#0044C614", padding: "12px", borderRadius: "0 0 8px 8px" }}>
        <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>Save</Button>
      </div>
      <ToastContainer toastClassName="email-toast-success" />
      {/* </Box> */}

      {isDialogSendOtpOldNum &&
        <Dialog
          open={isDialogSendOtpOldNum}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                <p className="paragraph-text">Verify your Old Mobile Number</p>
                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                <div>
                  <div className=''>
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {errorMessage ? (
                        <div style={{ color: 'red', marginTop: '10px' }}>
                          {errorMessage}
                        </div>
                      ) : (
                        <div style={{ marginTop: '10px' }}>
                        </div>
                      )}
                    </div>

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div className="next-button-container" style={{ gap: "16px" }}>
                        <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                          type="submit" onClick={handleCodeSubmitOldNum}
                          disabled={code.trim() === ''}>
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail? <button className="button-style-height" onClick={sendOtpOldNumber}>RESEND</button>
                    </div>

                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      }

      {isDialogSendOtpNewNum &&
        <Dialog
          open={isDialogSendOtpNewNum}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                <p className="paragraph-text">Verify your New Mobile Number</p>
                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                <div>
                  <div className=''>
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {errorMessage ? (
                        <div style={{ color: 'red', marginTop: '10px' }}>
                          {errorMessage}
                        </div>
                      ) : (
                        <div style={{ marginTop: '10px' }}>
                        </div>
                      )}
                    </div>

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div className="next-button-container" style={{ gap: "16px" }}>
                        <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                          type="submit" onClick={handleCodeSubmitNewNum}
                          disabled={code.trim() === ''}>
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail? <button className="button-style-height" onClick={sendOTPNewNumber}>RESEND</button>
                    </div>

                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      }
      {isDialogOldEmail &&
        <Dialog
          open={isDialogOldEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                <p className="paragraph-text">Verify your Old E-mail ID</p>
                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                <div>
                  <div className=''>
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                      </div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div className="next-button-container" style={{ gap: "16px" }}>
                        <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                          type="submit" onClick={handleCodeSubmitOldEmail}
                          disabled={code.trim() === ''}>
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail? <button className="button-style-height" onClick={SendOtpOldEmail}>RESEND</button>
                    </div>

                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      }

      {isDialogNewEmail &&
        <Dialog
          open={isDialogNewEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                <div>
                  <div className=''>
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                      </div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div className="next-button-container" style={{ gap: "16px" }}>
                        <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                          type="submit" onClick={handleCodeSubmitNewEmail}
                          disabled={code.trim() === ''}>
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail? <button className="button-style-height" onClick={sendOtpNewEmail}>RESEND</button>
                    </div>

                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      }
    </div>
  )
}

export default Contactdetails